/* eslint-disable @typescript-eslint/no-unsafe-function-type */
/**
 * Décorateur de classe.
 * Indique que ce composant doit déclencher une mise à jour complète (`_p_update`)
 * à chaque modification d'un attribut observé.
 *  Cela évite d'avoir à surcharger manuellement `_p_isUpdateForAllAttributes`.
 * @example
 * ```tsx
 * // imports ...
 *
 * @Define({ ... })
 * @UpdateAll()
 * export class MyComponent extends BnumElementInternal { ... }
 * ```
 */
export function UpdateAll() {
	return function (_: Function, context: ClassDecoratorContext) {
		if (context.kind !== 'class') {
			throw new Error('@UpdateAll ne peut être utilisé que sur une classe.');
		}

		context.addInitializer(function () {
			(
				this as unknown as { __CONFIG_UPDATE_ALL__: boolean }
			).__CONFIG_UPDATE_ALL__ = true;
		});
	};
}
